import React from 'react';
import PropTypes from 'prop-types';

class AuthLoginByFacebookTokenWrapperComponent extends React.Component {
  static propTypes = {
    loginViaFacebook: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.loginViaFacebook();
  }

  render() {
    return null;
  }
}

export default AuthLoginByFacebookTokenWrapperComponent;
